import React from "react";
import {
    Badge,
    Card,
    CardBody, CardFooter, CardHeader, CardTitle,
    Gallery,
    GalleryItem, Skeleton,
} from "@patternfly/react-core";
import {AiOutlineFile, AiOutlineFileImage} from "react-icons/ai";
import {GalleryItemData} from "../../Context/ItemsProvider/ItemsProviderDomain";
import {useItemsState} from "../../Context/ItemsProvider/ItemsProvider";

interface ViewProps{
    items: GalleryItemData[];
    selectedItems: string[];
    onClickItem: ( newId:string) => void;
}

export const DashboardGalleryItems: React.FunctionComponent<ViewProps> = (props) => {
    const { isLoading} = useItemsState()

    const items = React.useMemo( ()=>{
        if( isLoading ) return null

        return props.items.map( item => (
            <GalleryItem key={ item.id } >
                <Card isFullHeight isSelectableRaised
                      isSelected={ props.selectedItems.indexOf( item.id ) >= 0 }
                      onClick={ ()=>{ props.onClickItem( item.id ) } }
                >
                    <CardHeader>
                        <CardTitle component="h5">
                            {
                                (item.is_image ) ?
                                    <AiOutlineFileImage /> :
                                    <AiOutlineFile />
                            }{' '}
                            { item.name }
                        </CardTitle>
                    </CardHeader>

                    <CardBody>
                        { item.file_description }
                    </CardBody>
                    <CardFooter>
                        <Badge isRead>Vence en: { item.human_valid }</Badge>{' '}
                        <Badge isRead>{ item.human_size }</Badge>{' '}

                    </CardFooter>
                </Card>
            </GalleryItem>
        ) )
    }, [ props, isLoading ] )

    const skeleton = React.useMemo( ()=>{
        if (!isLoading) return null;
        const arrBase = Array(10).fill( 1 );
        return arrBase.map( (_value, index) => (
            <GalleryItem key={ index } >
                <Card isFullHeight>
                    <CardTitle>
                        <Skeleton height="100%" width="100%" screenreaderText="Cargando Elementos" />
                    </CardTitle>
                    <CardBody>
                        <Skeleton height="100px" width="100%" screenreaderText="Cargando Elementos" />
                    </CardBody>
                    <CardFooter>
                        <Skeleton height="100%" width="100%" screenreaderText="Cargando Elementos" />
                    </CardFooter>
                </Card>
            </GalleryItem>
        ) )
    }, [isLoading] )

    return (
        <Gallery hasGutter>
            {  (isLoading) ? skeleton : items  }
        </Gallery>
    )
}